import { inject, Pipe, PipeTransform } from '@angular/core';

import { ProductPrice } from './model/product-price';
import { StorefrontContext } from './service/storefront-context';

/** What the shop calls the currencies it stores. A code with no name here prints as it comes. */
const NAMES: Record<string, string> = { UAH: 'грн.' };

/**
 * Money, the way the shop prints it: no decimals on a whole amount, exactly two otherwise,
 * Ukrainian separators, and the currency the price is in.
 */
@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {

  private context = inject(StorefrontContext);

  transform(price: ProductPrice | null | undefined): string {
    if (!price || price.value === null || price.value === undefined) {
      return '';
    }
    return `${amount(price.value)} ${this.currency(price.currency)}`;
  }

  /**
   * A price says what it is in. Nothing stores a currency yet, so in practice the shop's own
   * answers for every one of them.
   */
  private currency(code: string | null | undefined): string {
    if (!code) {
      return this.context.currency();
    }
    return NAMES[code] ?? code;
  }

}

function amount(value: number): string {
  const digits = Number.isInteger(value) ? 0 : 2;
  return new Intl.NumberFormat('uk-UA', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value);
}
